export enum Platform {
  TIKTOK = "TIKTOK",
  AMAZON = "AMAZON",
}

export enum WorkflowStatus {
  WORKFLOW_STARTED = "workflow_started",
  WORKFLOW_FINISHED = "workflow_finished",
  WORKFLOW_FAILED = "workflow_failed",
  NODE_STARTED = "node_started",
  NODE_FINISHED = "node_finished",
}

export interface WorkflowEvent {
  event_type: WorkflowStatus;
  node_display_name: {
    zh: string;
    en: string;
  };
  node_id?: string;
  failure_reason?: {
    zh: string;
    en: string;
  };
}

export interface ScriptResult {
  scriptList: {
    end_time: string;
    labels: string[];
    pattern: string;
    pattern_zh: string;
    pattern_en: string;
    sentence: string;
    sentence_en: string;
    start_time: string;
    script_structure: string;
    translation_zh: string;
    translation_en: string;
    sub_translation: {
      ms: number;
      sentence: string;
      start_time: string;
      translation: string;
      translation_en: string;
      translation_zh: string;
    }[];
  }[];
  scriptVariables: {
    key: string;
    zh: string;
    en: string;
  }[];
  storyBoards: {
    start_time: string;
    end_time: string;
    start_time_ms: number;
    end_time_ms: number;
    scene_sport_en: string;
    scene_sport_zh: string;
    scene_type_en: string;
    scene_type_zh: string;
    shot_description_zh: string;
    shot_description_en: string;
  }[];
  transcription: {
    sentence: string;
    translation: string;
  }[];
}
export type VideoDeconstructionData = {
  explain_zh: string;
  label_zh: string;
  ref_zh: Record<string, string>;
};

export interface WorkflowResult {
  brand: string;
  product_selling_points: {
    selling_point: string;
    pain_point: string;
    usage_scenario: string;
  }[];
  l1_category: string;
  l2_category: string;
  l3_category: string;
}

export interface Category {
  option_name: string;
  children: Category[];
}
export interface FlattenedCategory {
  l1CategoryLabel: string;
  l2CategoryLabel: string;
  l3CategoryLabel: string;
  l1Category: string;
  l2Category: string;
  l3Category: string;
}

export interface OtherOptions {
  style_type: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
      explain_zh: string;
      explain_en: string;
    }[];
  };
  cta_type: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
      explain_zh: string;
      explain_en: string;
    }[];
  };
  age_range: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
    }[];
  };
  audience_gender: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
    }[];
  };
  audience_consumption_power: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
    }[];
  };
  sensitive_words: {
    is_multi_select: boolean;
    options: {
      word: string;
      translation: string;
      reason: string;
    }[];
  };
  custom_context_default_option: {
    is_multi_select: boolean;
    options: {
      key: string;
      option_zh: string;
      option_en: string;
    }[];
  };
}

export interface ScriptTaskResult {
  script_id: string;
  storyboard: {
    shot_no: number;
    structure: string;
    description: string;
    sentence: string;
    translation: string;
    translated_description: string;
  }[];
}
